import NoDataImage from 'assets/no-data.png';
import { cn } from 'lib/utils';

interface NoDataProps {
  className?: string;
  message: string;
}

export default function NoData({ className, message }: NoDataProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center h-full lg:border rounded-2xl border-primary',
        className
      )}
    >
      <div className='size-40'>
        <img
          src={NoDataImage}
          alt='no data'
          className='object-cover w-full h-full'
        />
      </div>
      <p>{message}</p>
    </div>
  );
}
